var swiper = new Swiper(".aboutSwiper", {
  slidesPerView: 'auto',
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  on:{
    init: function (swiper) {
      if (!isMobile() || $(window).width() > 768) {
        this.disable();
        this.params.slidesPerView = 'auto'
      }
    },
    resize: function (swiper) {
      if (isMobile() || $(window).width() <= 768) {
        this.update();
        this.enable();
        this.params.slidesPerView = '1'
      } else {
        this.disable();
      }
    }
  }
});

